<template>
  <div>
    <div v-if="label" class="input-label">
      {{ configuredLabel }}
      <NbHelpText
        v-if="helpText"
        :id="`${id}-popover`"
        :size="helpTextSize"
        placement="topright"
      >
        {{ helpText }}
      </NbHelpText>
    </div>
    <div class="d-flex mb-0">
      <input
        v-model="content"
        :id="id"
        class="mr-2 nb-checkbox"
        :class="disabled ? 'not-allowed' : ''"
        :style="boxStyle"
        :disabled="disabled"
        @change.stop="handleInput"
        type="checkbox"
      />
      <label
        class="nbcheckbox-label pointer"
        :class="disabled ? 'not-allowed' : ''"
        :for="id"
        :style="labelStyle"
      >
        {{ name }}
        <NbHelpText
          v-if="nameHelpText"
          :id="`${id}-popover-nameHelpText`"
          :size="helpTextSize"
          placement="topright"
        >
          {{ nameHelpText }}
        </NbHelpText>
      </label>
    </div>
    <ErrorFeedback :error="error[0]" />
  </div>
</template>

<script>
import ErrorFeedback from "../generic/ErrorFeedback.vue";
import NbHelpText from "@/components/generic/NbHelpText.vue";

export default {
  components: {
    ErrorFeedback,
    NbHelpText,
  },
  props: {
    id: {
      type: String,
      required: true,
    },
    name: {
      type: String,
      required: false,
    },
    label: {
      type: String,
      required: false,
    },
    labelStyle: {
      type: String,
      required: false,
    },
    boxStyle: {
      type: String,
      required: false,
    },
    value: {
      type: Boolean,
      required: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    nameHelpText: {
      type: String,
      required: false,
    },
    helpText: {
      type: String,
      required: false,
    },
    helpTextSize: {
      type: String,
      default: "sm",
    },
    required: {
      type: Boolean,
      required: false,
    },
    error: {
      type: Array,
      required: false,
      default: () => [],
    },
  },
  data() {
    return {
      content: this.value,
    };
  },
  methods: {
    handleInput() {
      this.$emit("input", this.content);
    },
    validateContent() {
      if (typeof this.required == "boolean") {
        this.$emit("valid", this.id);
      }
    },
  },
  computed: {
    configuredLabel() {
      if (this.required) {
        return `${this.label} *`;
      }
      return this.label;
    },
  },
  watch: {
    content(newValue) {
      this.$emit("input", newValue);
      this.validateContent();
    },
    value(newValue) {
      this.content = newValue;
    },
  },
};
</script>

<style scoped>
input[type="checkbox"].nb-checkbox {
  min-width: 1rem;
  height: 1rem;
}
/* input[type="checkbox"].nb-checkbox:focus {
  box-shadow: 0px 0px 0px 1px var(--primary) !important;
} */
input[type="checkbox"].nb-checkbox:hover {
  filter: invert(20%) sepia(2%) saturate(592%) hue-rotate(238deg)
    brightness(114%) contrast(81%);
}
input[type="checkbox"].nb-checkbox:checked {
  accent-color: #34495e;
}
input[type="checkbox"].nb-checkbox:checked:hover {
  filter: none;
}
input[type="checkbox"] + label {
  margin-bottom: 0px;
  font: normal normal normal 14px/18px var(--font-family-base);
  letter-spacing: 0px;
  color: var(--gray-60);
}
input[type="checkbox"] + label:hover {
  color: var(--black);
}
input[type="checkbox"]:checked + label {
  font: normal normal 600 14px/18px var(--font-family-base);
  color: var(--black);
}
</style>
